"use client";

import { useState } from "react";
import Logo from "./Logo";
import TextField from "./TextField";
import Button from "./Button";
import { AccountView } from "@/lib/types";

/** アカウント作成フォーム */
export default function SignupForm({
  onCreated,
  onCancel,
}: {
  onCreated: (account: AccountView) => void;
  onCancel: () => void;
}) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit() {
    if (password !== confirm) {
      setMessage("パスワードが一致しません");
      return;
    }

    setBusy(true);
    setMessage("");
    try {
      const response = await fetch("/api/auth/signup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      const body = await response.json();
      if (!response.ok) {
        setMessage(body.error ?? "アカウントを作成できませんでした");
        return;
      }
      onCreated(body.account as AccountView);
    } catch {
      setMessage("サーバーに繋がりません");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="panel panel-scene panel-login">
      <Logo />
      <form
        onSubmit={(event) => {
          event.preventDefault();
          submit();
        }}
      >
        <TextField
          id="signup-username"
          label="ユーザー名"
          value={username}
          onChange={setUsername}
          note="半角英数字とハイフン・アンダースコアで 3 文字から 32 文字"
          autoComplete="username"
          disabled={busy}
        />
        <TextField
          id="signup-password"
          label="パスワード"
          type="password"
          value={password}
          onChange={setPassword}
          note="8 文字以上"
          autoComplete="new-password"
          disabled={busy}
        />
        <TextField
          id="signup-confirm"
          label="パスワード（確認）"
          type="password"
          value={confirm}
          onChange={setConfirm}
          autoComplete="new-password"
          disabled={busy}
        />

        <div className="actions">
          <Button type="submit" variant="primary" disabled={busy}>
            決定
          </Button>
          <Button onClick={onCancel} disabled={busy}>
            キャンセル
          </Button>
        </div>
      </form>

      <p className="message">{message}</p>
    </div>
  );
}
